import { QuestionnaireRules as QuestionnaireRules_2_0_0 } from './QuestionnaireRecipes_2_0_0.js';
import { addRule, cloneRule, overwriteRule } from '../RecipeUtils.js';
/**
 * The rules to build a questionnaire based on FHIR
 */
export const QuestionnaireRules = cloneRule(QuestionnaireRules_2_0_0);
overwriteRule(QuestionnaireRules, 'item', {
    itemprop: 'item',
    inheritFrom: 'Questionnaire_2_1_0.item',
    optional: true
});
addRule(QuestionnaireRules, 'item', {
    itemprop: 'disabledDisplay',
    itemtype: { type: 'string', regexp: /protected|hidden/ },
    optional: false
});
/**
 * Recipe for questionnaires based upon FHIR standard.
 *
 * @type {{name: string; rule: RecipeRule[]; $type$: string}}
 */
export const QuestionnaireRecipe = {
    $type$: 'Recipe',
    name: 'Questionnaire_2_1_0',
    rule: QuestionnaireRules
};
const QuestionnaireRecipes = [QuestionnaireRecipe];
export default QuestionnaireRecipes;
//# sourceMappingURL=QuestionnaireRecipes_2_1_0.js.map